import go from '@/gojs/go'

const o4c = go.caracteristics.observa4

function toValue (d, l) {
  const v = d.values[1] == null ? 0 : d.values[1]
  const p = (100 * v / d.total).toFixed(0)
  const isNotCompliance = l.nc
  const c =
      isNotCompliance ? 'info'
        : p >= 90 ? 'success'
          : p >= 80 ? 'warning'
            : p >= 50 ? 'danger' : 'gray'

  const result = {
    v: p,
    cl: l.cl,
    ccl: `result-container-${l.cl} ${l.vl ? 'result-container-separator' : ''}`,
    c: c,
    st: l.st,
    t: l.t,
    i: l.i
  }

  let lowSampleSizeText = ''
  if (d.total < 30) {
    result.w = true
    lowSampleSizeText = `<br>
<span class="label label-warning">
  <small>
    <span class="glyphicon glyphicon-exclamation-sign"></span>
    Effectif faible
  </small>
</span>`
  }

  const sampleRatio = `<strong>${v}</strong> / <strong>${d.total}</strong>`
  const complianceText = `<i>${l.tt}</i>`
  const td = l.td == null ? 'Toutes les observations' : l.td
  const denominatorText = `<i>${td}</i>`
  result.tt = `${sampleRatio} observations.s
    ${lowSampleSizeText}
    <br><br><u>Conformité</u><br>${complianceText}
    <br><br><u>Dénominateur</u><br>${denominatorText}`

  result.splittedText = {
    sampleRatio: sampleRatio,
    complianceText: complianceText,
    denominatorText: denominatorText,
    lowSampleSizeText: lowSampleSizeText
  }

  return result
}

function indicatorFromGoCarac (d, carac, cl, nc, vl) {
  const legend = o4c.legends[carac.legend]
  const indicator = o4c.indicators[carac.indicator]
  return {
    v: d[carac.key],
    f: {
      c: legend.title,
      cl: cl,
      t: indicator.title,
      tt: indicator.condition,
      i: indicator.icon,
      st: indicator.subtitle,
      td: indicator.denominator === '' ? null : indicator.denominator,
      nc: nc,
      vl: vl
    }
  }
}

function summary (d, facts, year) {
  const igo = (g, notCompiance) => indicatorFromGoCarac(d, g, null, notCompiance)
  const label = (d, h) => {
    const l = o4c.legends[d]
    return h ? `<strong>${l.title}</stong>` : l.title
  }

  const result = [
    {
      key: 'adt',
      lines: [
        {
          l: label('compliantAuditedOutfitAndHDM', true),
          p1: igo(o4c.p1.p1CompliantAuditedOutfitAndHDM),
          p2: igo(o4c.p2.p2CompliantAuditedOutfitAndHDM),
          p3: igo(o4c.p3.p3CompliantAuditedOutfitAndHDM),
          p4: igo(o4c.p4.p4CompliantAuditedOutfitAndHDM),
          b1: igo(o4c.b1.b1CompliantAuditedOutfitAndHDM),
          b2: igo(o4c.b2.b2CompliantAuditedOutfitAndHDM),
          r1: igo(o4c.r1.r1CompliantAuditedOutfitAndHDM)
        },
        {
          l: label('sterileGown'),
          p1: igo(o4c.p1.p1SterileGown)
        },
        {
          l: label('compliantAuditedCap'),
          p1: igo(o4c.p1.p1CompliantAuditedCap),
          p3: igo(o4c.p3.p3CompliantAuditedCap),
          b2: igo(o4c.b2.b2CompliantAuditedCap),
          r1: igo(o4c.r1.r1CompliantAuditedCap)
        },
        {
          l: label('compliantAuditedMask'),
          p1: igo(o4c.p1.p1CompliantAuditedMask),
          p3: igo(o4c.p3.p3CompliantAuditedMask),
          b2: igo(o4c.b2.b2CompliantAuditedMask),
          r1: igo(o4c.r1.r1CompliantAuditedMask)
        },
        {
          l: label('auditedCleanOutfit'),
          p2: igo(o4c.p2.p2AuditedCleanOutfit),
          p3: igo(o4c.p3.p3AuditedCleanOutfit),
          p4: igo(o4c.p4.p4AuditedCleanOutfit),
          b1: igo(o4c.b1.b1AuditedCleanOutfit),
          b2: igo(o4c.b2.b2AuditedCleanOutfit),
          r1: igo(o4c.r1.r1AuditedCleanOutfit)
        },
        {
          l: label('compliantAsepsis'),
          p1: igo(o4c.p1.p1CompliantAsepsis),
          p2: igo(o4c.p2.p2CompliantAsepsis),
          p3: igo(o4c.p3.p3CompliantAsepsis),
          p4: igo(o4c.p4.p4CompliantAsepsis),
          b1: igo(o4c.b1.b1CompliantAsepsis),
          b2: igo(o4c.b2.b2CompliantAsepsis),
          r1: igo(o4c.r1.r1CompliantAsepsis)
        }
      ]
    },
    {
      key: 'pat',
      lines: [
        {
          l: label('compliantPatientOutfit', true),
          p1: igo(o4c.p1.p1CompliantPatientAdultOutfit),
          p2: igo(o4c.p2.p2CompliantPatientOutfit),
          p3: igo(o4c.p3.p3CompliantPatientAdultOutfit),
          p4: igo(o4c.p4.p4CompliantPatientOutfit),
          b2: igo(o4c.b2.b2CompliantPatientAdultOutfit),
          r1: igo(o4c.r1.r1CompliantPatientAdultOutfit)
        },
        {
          l: label('patientAdultCleanOutfit'),
          p1: igo(o4c.p1.p1PatientAdultCleanOutfit),
          p3: igo(o4c.p3.p3PatientAdultCleanOutfit),
          b2: igo(o4c.b2.b2PatientAdultCleanOutfit)
        },
        {
          l: label('compliantPatientAdultCap'),
          p1: igo(o4c.p1.p1CompliantPatientAdultCapOrSterileField)
        },
        {
          l: label('compliantPatientAdultMask'),
          p1: igo(o4c.p1.p1CompliantPatientAdultMaskOrSterileField),
          p3: igo(o4c.p3.p3CompliantPatientAdultMaskOrTurned),
          b2: igo(o4c.b2.b2CompliantPatientAdultMaskOrTurned)
        }
      ]
    },
    {
      key: 'pcut',
      lines: [
        {
          l: label('compliantAdultSkinPreparation', true),
          p1: igo(o4c.p1.p1CompliantAdultSkinPreparation),
          p2: igo(o4c.p2.p2CompliantAdultSkinPreparation),
          p3: igo(o4c.p3.p3CompliantAdultSkinPreparation),
          p4: igo(o4c.p4.p4CompliantAdultSkinPreparation),
          r1: igo(o4c.r1.r1CompliantAdultSkinPreparation)
        },
        {
          l: label('compliantAdultCleaning'),
          p1: igo(o4c.p1.p1CompliantAdultCleaning),
          p2: igo(o4c.p2.p2CompliantAdultCleaning),
          p3: igo(o4c.p3.p3CompliantAdultCleaning),
          p4: igo(o4c.p4.p4CompliantAdultCleaning),
          r1: igo(o4c.r1.r1CompliantAdultCleaning)
        },
        {
          l: label('compliantAdultCompresses'),
          p1: igo(o4c.p1.p1CompliantAdultCompresses),
          p2: igo(o4c.p2.p2CompliantAdultCompresses),
          p3: igo(o4c.p3.p3CompliantAdultCompresses),
          p4: igo(o4c.p4.p4CompliantAdultCompresses),
          r1: igo(o4c.r1.r1CompliantAdultCompresses)
        },
        {
          l: label('adultAlcoolicAntiseptic'),
          p1: igo(o4c.p1.p1AdultChlorexidine2Percent),
          p2: igo(o4c.p2.p2AdultAlcoolicAntiseptic),
          p3: igo(o4c.p3.p3AdultAlcoolicAntiseptic),
          p4: igo(o4c.p4.p4AdultAlcoolicAntiseptic),
          r1: igo(o4c.r1.r1AdultAlcoolicAntiseptic)
        },
        {
          l: label('adultSpontaneousDrying'),
          p1: igo(o4c.p1.p1AdultSpontaneousDrying),
          p2: igo(o4c.p2.p2AdultSpontaneousDrying),
          p3: igo(o4c.p3.p3AdultSpontaneousDrying),
          p4: igo(o4c.p4.p4AdultSpontaneousDrying),
          r1: igo(o4c.r1.r1AdultSpontaneousDrying)
        },
        {
          l: label('systematicAdultCleaning'),
          r1: igo(o4c.r1.r1SystematicAdultCleaning, true)
        }
      ]
    },
    {
      key: 'manip',
      lines: [
        {
          l: label('compliantHookupSitePreparation', true),
          b1: igo(o4c.b1.b1CompliantHookupSitePreparation),
          b2: igo(o4c.b2.b2CompliantHookupSitePreparation)
        },
        {
          l: label('compliantCompresses'),
          b1: igo(o4c.b1.b1CompliantCompresses),
          b2: igo(o4c.b2.b2CompliantCompresses)
        },
        {
          l: label('alcool70'),
          b1: igo(o4c.b1.b1Alcool70),
          b2: igo(o4c.b2.b2Alcool70)
        },
        {
          l: label('valveDisinfection'),
          b1: igo(o4c.b1.b1ValveDisinfection),
          b2: igo(o4c.b2.b2ValveDisinfection)
        },
        {
          l: label('compliantValveDisinfection'),
          b1: igo(o4c.b1.b1CompliantValveDisinfection),
          b2: igo(o4c.b2.b2CompliantValveDisinfection)
        },
        {
          l: label('valveAlcool70'),
          b1: igo(o4c.b1.b1ValveAlcool70),
          b2: igo(o4c.b2.b2ValveAlcool70)
        }
      ]
    },
    {
      key: 'ultrasound',
      lines: [
        {
          l: label('compliantUltrasoundAtInsertion', true),
          p1: igo(o4c.p1.p1CompliantUltrasoundAtInsertion),
          p2: igo(o4c.p2.p2CompliantUltrasoundAtInsertion)
        },
        {
          l: label('ultrasoundSterileGelAndSheath'),
          p1: igo(o4c.p1.p1UltrasoundSterileGelAndSheath),
          p2: igo(o4c.p2.p2UltrasoundSterileGelAndSheath)
        },
        {
          l: label('ultrasoundCompliantAsepsis'),
          p1: igo(o4c.p1.p1UltrasoundCompliantAsepsis),
          p2: igo(o4c.p2.p2UltrasoundCompliantAsepsis)
        },
        {
          l: label('ultrasoundCompliantGloves'),
          p2: igo(o4c.p2.p2UltrasoundCompliantGloves)
        }
      ]
    },
    {
      key: 'rinsingDiscontinuous',
      lines: [
        {
          l: `<strong>Opportunité du rinçage pulsé (utilisation du cathéter en discontinu)</strong>`
        },
        {
          l: label('compliantDiscontinuousConnectionRinsingTiming'),
          b1: igo(o4c.b1.b1DiscontinuousConnectionCompliantRinsingTiming),
          b2: igo(o4c.b2.b2DiscontinuousConnectionCompliantRinsingTiming)
        },
        {
          l: label('compliantDiscontinuousDisconnectionRinsingTiming'),
          b1: igo(o4c.b1.b1DiscontinuousDisconnectionCompliantRinsingTiming),
          b2: igo(o4c.b2.b2DiscontinuousDisconnectionCompliantRinsingTiming)
        },
        {
          l: label('compliantDiscontinuousInjectionRinsingTiming'),
          b1: igo(o4c.b1.b1DiscontinuousInjectionCompliantRinsingTiming),
          b2: igo(o4c.b2.b2DiscontinuousInjectionCompliantRinsingTiming)
        },
        {
          l: label('compliantDiscontinuousSamplingRinsingTiming'),
          b1: igo(o4c.b1.b1DiscontinuousSamplingCompliantRinsingTiming),
          b2: igo(o4c.b2.b2DiscontinuousSamplingCompliantRinsingTiming)
        },
        {
          l: label('compliantCCIDiscontinuousNeedleRemovalRinsingTiming'),
          b2: igo(o4c.b2.b2CCIDiscontinuousNeedleRemovalCompliantRinsingTiming)
        }
      ]
    },
    {
      key: 'rinsingContinuous',
      lines: [
        {
          l: `<strong>Opportunité du rinçage pulsé (utilisation du cathéter en continu)</strong>`
        },
        {
          l: label('compliantCCIContinuousNeedleRemovalRinsingTiming'),
          b2: igo(o4c.b2.b2CCIContinuousNeedleRemovalCompliantRinsingTiming)
        },
        {
          l: label('compliantContinuousSamplingRinsingTiming'),
          b1: igo(o4c.b1.b1ContinuousSamplingCompliantRinsingTiming),
          b2: igo(o4c.b2.b2ContinuousSamplingCompliantRinsingTiming)
        }
      ]
    },

    {
      key: 'rinsingTechnique',
      lines: [
        {
          l: `<strong>Technique du rinçage pulsé</strong>`
        },
        {
          l: label('compliantRinsingTechnique'),
          b1: igo(o4c.b1.b1CompliantRinsingTechnique),
          b2: igo(o4c.b2.b2CompliantRinsingTechnique)
        },

        {
          l: label('compliantRinsingProduct'),
          b1: igo(o4c.b1.b1CompliantRinsingProduct),
          b2: igo(o4c.b2.b2CompliantRinsingProduct)
        },
        {
          l: label('compliantRinsingElimination'),
          b1: igo(o4c.b1.b1CompliantRinsingElimination),
          b2: igo(o4c.b2.b2CompliantRinsingElimination)
        }
      ]
    }
  ]
  return result
}

function highlight (d, titles, subTitles, facts, year) {
  const item = (c, v) => {
    return {
      title: titles.byTheme[c],
      subTitle: subTitles.byTheme[c],
      class: c,
      values: v
    }
  }

  const igo = function (c, opt = {}) {
    const { big, notCompliance, separator } = opt
    return indicatorFromGoCarac(d, c, big ? 'big' : 'std', notCompliance, separator)
  }

  const bySheet = {
    p1: [
      item(
        'adt',
        [
          igo(o4c.p1.p1CompliantAuditedOutfitAndHDM, { big: true }),
          igo(o4c.p1.p1SterileGown),
          igo(o4c.p1.p1CompliantAuditedMask),
          igo(o4c.p1.p1CompliantAuditedCap),
          igo(o4c.p1.p1CompliantAsepsis)
        ]
      ),
      item(
        'pat',
        [
          igo(o4c.p1.p1CompliantPatientAdultOutfit, { big: true }),
          igo(o4c.p1.p1PatientAdultCleanOutfit),
          igo(o4c.p1.p1CompliantPatientAdultCapOrSterileField),
          igo(o4c.p1.p1CompliantPatientAdultMaskOrSterileField)
        ]
      ),
      item(
        'pcut',
        [
          igo(o4c.p1.p1CompliantAdultSkinPreparation, { big: true }),
          igo(o4c.p1.p1CompliantAdultCleaning),
          igo(o4c.p1.p1CompliantAdultCompresses),
          igo(o4c.p1.p1AdultChlorexidine2Percent),
          igo(o4c.p1.p1AdultSpontaneousDrying)
        ]
      ),
      item(
        'ultrasound',
        [
          igo(o4c.p1.p1CompliantUltrasoundAtInsertion, { big: true }),
          igo(o4c.p1.p1UltrasoundSterileGelAndSheath),
          igo(o4c.p1.p1UltrasoundCompliantAsepsis)
        ]
      )
    ],
    p2: [
      item(
        'adt',
        [
          igo(o4c.p2.p2CompliantAuditedOutfitAndHDM, { big: true }),
          igo(o4c.p2.p2AuditedCleanOutfit),
          igo(o4c.p2.p2CompliantAsepsis)
        ]
      ),
      item(
        'pat', [ igo(o4c.p2.p2CompliantPatientOutfit, { big: true }) ]
      ),
      item(
        'pcut',
        [
          igo(o4c.p2.p2CompliantAdultSkinPreparation, { big: true }),
          igo(o4c.p2.p2CompliantAdultCleaning),
          igo(o4c.p2.p2CompliantAdultCompresses),
          igo(o4c.p2.p2AdultAlcoolicAntiseptic),
          igo(o4c.p2.p2AdultSpontaneousDrying)
        ]
      ),
      item(
        'ultrasound',
        [
          igo(o4c.p2.p2CompliantUltrasoundAtInsertion, { big: true }),
          igo(o4c.p2.p2UltrasoundSterileGelAndSheath),
          igo(o4c.p2.p2UltrasoundCompliantAsepsis),
          igo(o4c.p2.p2UltrasoundCompliantGloves)
        ]
      )
    ],
    p3: [
      item(
        'adt',
        [
          igo(o4c.p3.p3CompliantAuditedOutfitAndHDM, { big: true }),
          igo(o4c.p3.p3CompliantAuditedCap),
          igo(o4c.p3.p3CompliantAuditedMask),
          igo(o4c.p3.p3AuditedCleanOutfit),
          igo(o4c.p3.p3CompliantAsepsis)
        ]
      ),
      item(
        'pat',
        [
          igo(o4c.p3.p3CompliantPatientAdultOutfit, { big: true }),
          igo(o4c.p3.p3PatientAdultCleanOutfit),
          igo(o4c.p3.p3CompliantPatientAdultMaskOrTurned)
        ]
      ),
      item(
        'pcut',
        [
          igo(o4c.p3.p3CompliantAdultSkinPreparation, { big: true }),
          igo(o4c.p3.p3CompliantAdultCleaning),
          igo(o4c.p3.p3CompliantAdultCompresses),
          igo(o4c.p3.p3AdultAlcoolicAntiseptic),
          igo(o4c.p3.p3AdultSpontaneousDrying)
        ]
      )
    ],
    p4: [
      item(
        'adt',
        [
          igo(o4c.p4.p4CompliantAuditedOutfitAndHDM, { big: true }),
          igo(o4c.p4.p4AuditedCleanOutfit),
          igo(o4c.p4.p4CompliantAsepsis)
        ]
      ),
      item(
        'pat', [ igo(o4c.p4.p4CompliantPatientOutfit, { big: true }) ]
      ),
      item(
        'pcut',
        [
          igo(o4c.p4.p4CompliantAdultSkinPreparation, { big: true }),
          igo(o4c.p4.p4CompliantAdultCleaning),
          igo(o4c.p4.p4CompliantAdultCompresses),
          igo(o4c.p4.p4AdultAlcoolicAntiseptic),
          igo(o4c.p4.p4AdultSpontaneousDrying)
        ]
      )
    ],
    b1: [
      item(
        'adt',
        [
          igo(o4c.b1.b1CompliantAuditedOutfitAndHDM, { big: true }),
          igo(o4c.b1.b1AuditedCleanOutfit),
          igo(o4c.b1.b1CompliantAsepsis)
        ]
      ),
      item(
        'manip',
        [
          igo(o4c.b1.b1CompliantHookupSitePreparation, { big: true }),
          igo(o4c.b1.b1CompliantCompresses),
          igo(o4c.b1.b1Alcool70),
          igo(o4c.b1.b1ValveDisinfection),
          igo(o4c.b1.b1CompliantValveDisinfection),
          igo(o4c.b1.b1ValveAlcool70)
        ]
      ),
      item(
        'rinsingTechnique',
        [
          igo(o4c.b1.b1CompliantRinsingTechnique),
          igo(o4c.b1.b1CompliantRinsingProduct),
          igo(o4c.b1.b1CompliantRinsingElimination)
        ]
      ),
      item(
        'rinsingDiscontinuous',
        [
          igo(o4c.b1.b1DiscontinuousConnectionCompliantRinsingTiming),
          igo(o4c.b1.b1DiscontinuousDisconnectionCompliantRinsingTiming),
          igo(o4c.b1.b1DiscontinuousInjectionCompliantRinsingTiming),
          igo(o4c.b1.b1DiscontinuousSamplingCompliantRinsingTiming)
        ]
      ),
      item(
        'rinsingContinuous',
        [
          igo(o4c.b1.b1ContinuousSamplingCompliantRinsingTiming)
        ]
      )
    ],
    b2: [
      item(
        'adt',
        [
          igo(o4c.b2.b2CompliantAuditedOutfitAndHDM, { big: true }),
          igo(o4c.b2.b2CompliantAuditedMask),
          igo(o4c.b2.b2AuditedCleanOutfit),
          igo(o4c.b2.b2CompliantAsepsis),
          igo(o4c.b2.b2CompliantAuditedCap)
        ]
      ),
      item(
        'pat',
        [
          igo(o4c.b2.b2CompliantPatientAdultOutfit, { big: true }),
          igo(o4c.b2.b2PatientAdultCleanOutfit),
          igo(o4c.b2.b2CompliantPatientAdultMaskOrTurned)
        ]
      ),
      item(
        'manip',
        [
          igo(o4c.b2.b2CompliantHookupSitePreparation, { big: true }),
          igo(o4c.b2.b2CompliantCompresses),
          igo(o4c.b2.b2Alcool70),
          igo(o4c.b2.b2ValveDisinfection),
          igo(o4c.b2.b2CompliantValveDisinfection),
          igo(o4c.b2.b2ValveAlcool70)
        ]
      ),
      item(
        'rinsingTechnique',
        [
          igo(o4c.b2.b2CompliantRinsingTechnique),
          igo(o4c.b2.b2CompliantRinsingProduct),
          igo(o4c.b2.b2CompliantRinsingElimination)
        ]
      ),
      item(
        'rinsingDiscontinuous',
        [
          igo(o4c.b2.b2DiscontinuousConnectionCompliantRinsingTiming),
          igo(o4c.b2.b2DiscontinuousDisconnectionCompliantRinsingTiming),
          igo(o4c.b2.b2DiscontinuousInjectionCompliantRinsingTiming),
          igo(o4c.b2.b2DiscontinuousSamplingCompliantRinsingTiming),
          igo(o4c.b2.b2CCIDiscontinuousNeedleRemovalCompliantRinsingTiming)
        ]
      ),
      item(
        'rinsingContinuous',
        [
          igo(o4c.b2.b2ContinuousSamplingCompliantRinsingTiming),
          igo(o4c.b2.b2CCIContinuousNeedleRemovalCompliantRinsingTiming)
        ]
      )
    ],
    r1: [
      item(
        'adt',
        [
          igo(o4c.r1.r1CompliantAuditedOutfitAndHDM, { big: true }),
          igo(o4c.r1.r1CompliantAuditedCap),
          igo(o4c.r1.r1CompliantAuditedMask),
          igo(o4c.r1.r1AuditedCleanOutfit),
          igo(o4c.r1.r1CompliantAsepsis)
        ]
      ),
      item(
        'pat',
        [
          igo(o4c.r1.r1CompliantPatientAdultOutfit, { big: true })
        ]
      ),
      item(
        'pcut',
        [
          igo(o4c.r1.r1CompliantAdultSkinPreparation, { big: true }),
          igo(o4c.r1.r1CompliantAdultCleaning),
          igo(o4c.r1.r1CompliantAdultCompresses),
          igo(o4c.r1.r1AdultAlcoolicAntiseptic),
          igo(o4c.r1.r1AdultSpontaneousDrying),
          igo(
            o4c.r1.r1SystematicAdultCleaning,
            { notCompliance: true, separator: true }
          )
        ]
      )
    ]
  }

  const byTheme = {}
  for (let key in titles.byTheme) {
    const bt = []
    for (let sheet in bySheet) {
      const list = bySheet[sheet]
      const bs = list.find(b => b.class === key)
      if (bs == null) {
        continue
      }

      bt.push(
        {
          title: titles.bySheet[sheet],
          class: sheet,
          values: bs.values
        }
      )
    }
    byTheme[key] = bt
  }

  return {
    bySheet: bySheet,
    byTheme: byTheme
  }
}

export default {
  toValue,
  summary,
  highlight
}
